import { bindEvents } from '../../assets/js/helpers';

const selector = 'hamburger';

export default class Hamburger {

	constructor(section) {
		this.el = {
			section,
			hitArea: section.querySelector(`.${selector}__hit-area`),
			line1: section.querySelector(`.${selector}__line:nth-child(1)`),
			line2: section.querySelector(`.${selector}__line:nth-child(2)`),
			line3: section.querySelector(`.${selector}__line:nth-child(3)`)
		};

		// bind events to class scope
		this.events = bindEvents(this);

		// class variable groups

		// class variable singles

		// engage
		this.init();
	}

	static get selector() {
		return selector;
	}

	// initialize class

	init() {
		this.addEventListeners();
	}

	// event listeners

	addEventListeners() {
		this.el.hitArea.addEventListener('click', this.events._onHitAreaClick);
	}

	removeEventListeners() {
		this.el.hitArea.removeEventListener('click', this.events._onHitAreaClick);
	}

	// listener methods

	_onHitAreaClick() {
		this.toggle();
	}

	//

	toggle() {
		if (this.el.section.classList.contains('is-active')) {
			this.collapse();
		} else {
			this.expand();
		}
	}

	expand() {
		this.el.section.classList.add('is-active');
	}

	collapse() {
		this.el.section.classList.remove('is-active');
	}

	// destroy

	destroy() {
		this.removeEventListeners();
	}

}
